import http from './axios'

const url = 'https://buyer.17track.net/orderapi/call'

const version = 'm1.0'
const timeZoneOffset = new Date().getTimezoneOffset()

// 获取列表
export const GetTrackInfoList = async (param: any) => {
  const result = await http.post(
    url,
    {
      version: version,
      method: "GetTrackInfoList",
      timeZoneOffset: timeZoneOffset,
      param
    }
  ) 
  return result
}

// 删除
export const DelTrackNo = async (TrackInfoIds: Array<string>) => {
  const result = await http.post(
    url,
    {
      version: version,
      method: "DelTrackNo",
      timeZoneOffset: timeZoneOffset,
      param: {
        TrackInfoIds
      }
    }
  ) 
  return result
}

// 激活
export const SetTrackActivate = async (TrackInfoIds: Array<string>) => {
  const result = await http.post(
    url,
    {
      version: version,
      method: "SetTrackActivate",
      timeZoneOffset: timeZoneOffset,
      param: {
        TrackInfoIds
      }
    }
  ) 
  return result
}

// 归档
export const SetTrackArchived = async (TrackInfoIds: Array<string>) => {
  const result = await http.post(
    url,
    {
      version: version,
      method: "SetTrackArchived",
      timeZoneOffset: timeZoneOffset,
      param: {
        TrackInfoIds
      }
    }
  ) 
  return result
}

// 获取限制数量
export const GetTrackLimitAmount = async () => {
  const result = await http.post(
    url,
    {
      version: 'a1.0',
      method: "GetTrackLimitAmount",
      timeZoneOffset: timeZoneOffset,
      param: ''
    }
  ) 
  return result
}

export const AddTrackInfos = async (tracks: Array<any>) => {
  const result = await http.post(
    url,
    {
      version: version,
      method: "AddTrackInfos",
      timeZoneOffset: timeZoneOffset,
      param: {
        tracks
      }
    }
  ) 
  return result
}

/**
 * 同步单号
 * @param TrackInfos {Array}
 *  no      单号
 *  rm      备注
 *  w1      第一运输商
 *  w2      第二运输商
 *  ts      追踪状态类型  0 无效追踪 1 待追踪 2 正在追踪 3 已完成
 *  ot      操作类型      1 新增 2 修改 4 删除
 *  isa     是否归档
 *  totop   置顶的时间戳
 */
export const SetOrderTrackNo = async (TrackInfos: Array<any>) => {
  const result = await http.post(
    url,
    {
      version: 'm2.2',
      method: "SetOrderTrackNo",
      timeZoneOffset: timeZoneOffset,
      param: {
        TrackInfos
      }
    }
  ) 
  return result
}